import { FaturaProfissionalListSearchComponent } from './FaturaProfissionalListSearchComponent'

export const FaturaProfissionalListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <FaturaProfissionalListSearchComponent />
  </div>
)
